<mat-toolbar color="accent">{{ data.title }}</mat-toolbar>

<form [formGroup]="form" (ngSubmit)="submit()">
  <mat-dialog-content>
    <div class="flex flex-col gap-4">
      <mat-form-field class="flex w-full">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" [required]="true" />
        <mat-hint
          >Each App provides a unique set of configuration settings and
          authentication needed for making requests to Principle Dental's API's.
          This will be displayed to the user in the Principle Dental OAuth
          flow.</mat-hint
        >
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <pt-buttons-container padding="none">
      <button type="button" mat-stroked-button mat-dialog-close>Cancel</button>
      <button mat-flat-button color="primary" [disabled]="form.invalid">
        Submit
      </button>
    </pt-buttons-container>
  </mat-dialog-actions>
</form>
